export const contactConfig = {
  email: {
    label: 'Email',
    address: 'kontakt@knjigacuda.rs',
    subjectPrefix: 'Upit za custom Knjigu Cuda',
  },
  telegram: {
    label: 'Telegram',
    handle: 'knjigacuda',
    baseUrl: 'https://t.me/knjigacuda',
  },
};

export const customHighlights = [
  'Mi dizajniramo knjigu',
  'Za one koji zele nesto posebno',
  'Pregled i korekcije pre stampe',
];

export const processStages = [
  'Posaljite nam fotografije i kratku ideju ili povod za knjigu.',
  'Dizajniramo raspored, stil i izgled knjige uz vasu potvrdu.',
  'Pripremamo stampu i saljemo vam gotovu Knjigu Cuda.',
];

export const faqItems = [
  {
    question: 'Kako funkcionise pravljenje knjige?',
    answer:
      '1. Posaljete fotografije i ideju. 2. Mi predlazemo izgled i raspored. 3. Kada potvrdite dizajn, knjigu pripremamo za stampu i isporuku.',
  },
  {
    question: 'Da li moram da znam dizajn ili da imam iskustva?',
    answer:
      'Ne. Dovoljno je da znate kome je knjiga namenjena i kakav utisak zelite. Mi vodimo dizajn i finalnu pripremu.',
  },
  {
    question: 'Koja je razlika izmedu "napravi sam" i custom knjige?',
    answer:
      'Kod custom opcije mi radimo dizajn, obradu i finalnu pripremu. "Napravi sam" je samostalniji proces koji je planiran za naredni milestone.',
  },
  {
    question: 'Koliko traje izrada i isporuka?',
    answer:
      'Rok zavisi od broja strana, kolicine materijala i termina stampe. Najbolje je da nam se javite sto ranije sa okvirnim rokom.',
  },
  {
    question: 'Da li mogu kasnije da napravim izmene?',
    answer:
      'Kod "napravi sam" opcije izmene su moguce dok ne posaljete knjigu u stampu. Kod custom knjige dobijate pregled pre stampe i tada mozete traziti korekcije.',
  },
];
